import { defineComponent as _defineComponent } from 'vue'
import { useTranslate } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'RetailerProductSizeModal',
  props: {
  sizingChartUrl: {
    type: String,
    required: true,
  },
},
  emits: ["open-modal-click"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "open-modal-click"): void;
}), expose: any, slots: any, attrs: any }) {

const { t } = useTranslate();





function onClick() {
  emits("open-modal-click");
}

const title = t("Size Chart");

return { __sfc: true,t, emits, onClick, title }
}

})